/**
 * A sala de vídeo da teleconsulta.
 *
 * Jitsi Meet: abre no navegador, sem conta e sem instalar nada, para a clínica e
 * para o paciente. O nome da sala é aleatório de verdade — uma sala com nome
 * previsível ("vecchia-clara-ribeiro") é uma consulta que qualquer um entra.
 */
export function gerarLinkDeTeleconsulta(): string {
    return `https://meet.jit.si/vecchia-${identificadorAleatorio()}`;
}

function identificadorAleatorio(): string {
    const c = globalThis.crypto;
    if (c && typeof c.randomUUID === 'function') return c.randomUUID();
    if (c && typeof c.getRandomValues === 'function') {
        const bytes = c.getRandomValues(new Uint8Array(16));
        return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    }
    throw new Error('Este navegador não gera identificador seguro para a sala de vídeo.');
}
